var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column justify-content-start align-items-start"},[_c('span',{staticClass:"badge badge-pill",class:_vm.currentStatus},[_vm._v("\n    "+_vm._s(_vm.statusText)+"\n  ")]),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.expiredDate))])])
}
var staticRenderFns = []

export { render, staticRenderFns }